<!-- notas -->
<core-helpers-box-loading [hidden]="preview.status_code==1"></core-helpers-box-loading>
<core-previews-carousel
    *ngIf="preview.total_pages > 1"
    [preview]="preview"
    (onClickPage)="selectPage($event)"
    [selectedPage]="page"
>
</core-previews-carousel>

<core-helpers-lists-ordered
    *ngIf="preview.status_code == 1"
    [elements]="list"
    [title]="'List notes'"
    (select)="onListSelect($event)">
</core-helpers-lists-ordered>

<core-notes-legacy
    *ngIf="preview.status_code == 1"
    [file]="file"
    [page]="page"
    [notes]="notes"
    [selected]="noteSelected"
    (onClick)="onClick.emit($event);"
>
</core-notes-legacy>
